import React from "react";
import { connect } from "react-redux";
import Overview from "./salesTabData";
// import SalesTrend from "./salesTrend";
import { AnalyticsActions, AnalyticsSelectors } from "../../modules/analytics";
import { AuthActions } from "../../modules/auth";
import "./styles.css";
import {
  Menu,
  Container,
  Dropdown,
  Header,
  Grid,
  Sidebar,
  List,
  Label,
  Tab,
  Table,
  Icon
} from "semantic-ui-react";
import Token from "../../helpers/token";
import { getSelectorAuth } from "../../modules/auth/AuthSelectors";
// import KE_Data from "./ke_data";
import Inventory from "./inventory";
import ProductAnalytics from "./productAnalytics";


const { authOnLogout, authOnInit } = AuthActions;
const { loadInitialAnalyticsState } = AnalyticsActions;
const { getSelectorAnalytics } = AnalyticsSelectors;

const TabData =Overview;

class Tabs extends React.Component {
  render() {
    let { analytics, product_analytics } = this.props;
    let { auth } = this.props;
    let panes = [
      {
        menuItem: "OVERVIEW",
        pane: { key: "tab1", content: <TabData {...analytics} /> }
      }
    ];

    let tabs = analytics.tabs || [];

    for (var i = 0; i < tabs.length; i++) {
      panes.push({
        menuItem: tabs[i].label.toUpperCase(),
        pane: {
          key: tabs[i].key,
          content: (
            <TabData
              {...(analytics[tabs[i].key]
                ? { ...analytics[tabs[i].key] }
                : { ...analytics })}
            />
          )
        }
      });
    }
    if (auth.filters) {
    //   if (auth.filters.has_charts)
    //     panes.push({
    //       menuItem: "TRENDS",
    //       pane: {
    //         key: "salesTrend",
    //         content: <SalesTrend {...analytics} />
    //       }
    //     });
      if (auth.filters.has_inventory) {
        panes.push({
          menuItem: "INVENTORY",
          pane: {
            key: "inventory",
            content: <Inventory {...analytics}/>
          }
      
        })
       }
       if (auth.filters.has_product_analytics) {
        panes.push({
          menuItem: "TOP 100 ANALYSIS",
          pane: {
            key: "productAnalytics",
            content: <ProductAnalytics {...analytics}/>
          }
      
        })
       }
      }

   

    return (
      <Grid.Column verticalAlign="top">
        <Tab panes={panes} renderActiveOnly={false} />
      </Grid.Column>
    );
  }
}

const styles = {
  headingText: {
    fontSize: 16,
    color: "#666874",
    paddingBottom: 20,
    paddingLeft: 20,
    fontWeight: 400,
    textTransform: "uppercase",
    fontFamily: "Roboto",
    textShadow: "none"
  },
  listMain: {
    borderStyle: "solid",
    borderBottomWidth: 1,
    borderBottomColor: "#f2f2f6",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
    alignSelf: "center",
    paddingTop: 20,
    paddingBottom: 20,
    paddingLeft: 0,
    paddingRight: 0,
    marginLeft: 15,
    marginRight: 15
  },
  valueIner: {
    fontSize: 16,
    fontWeight: 400,
    color: "#575757",
    fontFamily: "Roboto"
  },
  textIner: {
    fontSize: 14,
    fontWeight: 300,
    color: "#999999",
    fontFamily: "Roboto",
    textTransform: "capitalize"
  },
  values: {
    paddingTop: 10,
    // maxHeight:'370px',
    // overflowY:'scroll',
    // overflowX:'hidden',
    paddingBottom: 10,
    marginBottom: 30,
    height: 330,
    minHeight: 330,
    fontFamily: "Roboto",
    borderStyle: "solid",
    flexDirection: "row",
    justifyContent: "space-around",
    borderTopWidth: 1,
    borderTopColor: "#c1c1c5",
    textTransform: "capitalize"
  }
};

const mapStateToProps = state => {
  return {
    analytics: getSelectorAnalytics(state),
    auth: getSelectorAuth(state)
  };
};

export default connect(
  mapStateToProps,
  { loadInitialAnalyticsState }
)(Tabs);



// WEBPACK FOOTER //
// ./src/components/TabSales/index.js